/**
 * sidebar_mobile.js
 * Améliore l'expérience de la sidebar sur mobile
 */

// Initialiser les gestionnaires de la sidebar mobile
document.addEventListener('DOMContentLoaded', initMobileSidebar);
document.addEventListener('turbolinks:load', initMobileSidebar);

function initMobileSidebar() {
  const sidebar = document.getElementById('sidebar');
  const sidebarOverlay = document.getElementById('sidebarOverlay');
  const sidebarToggle = document.getElementById('sidebarToggle');
  const sidebarClose = document.getElementById('sidebarClose');

  if (!sidebar) return;

  // Fonction pour ouvrir la sidebar
  function openSidebar() {
    sidebar.classList.add('show');
    if (sidebarOverlay) sidebarOverlay.classList.add('show');
    document.body.classList.add('sidebar-open');
  }

  // Fonction pour fermer la sidebar
  function closeSidebar() {
    sidebar.classList.remove('show');
    if (sidebarOverlay) sidebarOverlay.classList.remove('show');
    document.body.classList.remove('sidebar-open');
  }

  // Attacher les écouteurs d'événements
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', (e) => {
      e.preventDefault();
      openSidebar();
    });
  }

  if (sidebarClose) {
    sidebarClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeSidebar();
    });
  }

  if (sidebarOverlay) {
    sidebarOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      closeSidebar();
    });
  }

  // Fermer la sidebar avec la touche Échap
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar.classList.contains('show')) {
      closeSidebar();
    }
  });

  // Fermer la sidebar automatiquement sur les grands écrans
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 992 && sidebar.classList.contains('show') && window.innerWidth < 768) {
      closeSidebar();
    }
  });

  // Améliorer l'interaction avec les liens de la sidebar sur mobile
  const sidebarLinks = sidebar.querySelectorAll('a.nav-link:not([data-bs-toggle])');
  sidebarLinks.forEach(link => {
    // Ajouter un effet de feedback tactile
    link.addEventListener('touchstart', function() {
      this.style.backgroundColor = '#e9ecef';
    });

    link.addEventListener('touchend', function() {
      this.style.backgroundColor = '';
    });

    // Fermer automatiquement la sidebar sur mobile après avoir cliqué sur un lien
    if (window.innerWidth < 768) {
      link.addEventListener('click', () => {
        setTimeout(closeSidebar, 150);
      });
    }
  });
}
